import { CARD_LAYOUTS, DEFAULT_CARD_LAYOUT } from "./cardRegions";

/**
 * Convert normalized CardRegions into actual pixel
 * coordinates inside a detected collectible boundary.
 *
 * CardRegions uses:
 *
 *     x:      0-1
 *     y:      0-1
 *     width:  0-1
 *     height: 0-1
 *
 * The detector uses:
 *
 *     x/y/width/height in actual pixels.
 */

export function resolveCardRegions(
    boundary,
    layout
) {
    if (
        !boundary ||
        !boundary.boundingBox
    ) {
        return null;
    }

    const boundingBox =
        boundary.boundingBox;

    const resolvedLayout =
        resolveLayout(
            layout
        );

    if (!resolvedLayout) {
        return null;
    }

    const regions = {};

    Object.entries(
        resolvedLayout.regions || {}
    ).forEach(
        ([name, region]) => {
            regions[name] =
                resolveRegion(
                    region,
                    boundingBox
                );
        }
    );

    return {
        name:
            layout?.name ||
            "DEFAULT_CARD_LAYOUT",

        presentation:
            resolvedLayout.presentation ||
            "unknown",

        grader:
            resolvedLayout.grader ||
            null,

        regions
    };
}


/**
 * Resolve one normalized region against
 * the detected collectible boundary.
 */
function resolveRegion(
    region,
    boundingBox
) {
    return {
        x:
            Math.round(
                boundingBox.x +
                boundingBox.width *
                    region.x
            ),

        y:
            Math.round(
                boundingBox.y +
                boundingBox.height *
                    region.y
            ),

        width:
            Math.round(
                boundingBox.width *
                    region.width
            ),

        height:
            Math.round(
                boundingBox.height *
                    region.height
            )
    };
}


/**
 * Resolve either:
 *
 *     { name: "PSA_SLAB", ... }
 *
 * or a direct layout definition.
 */
function resolveLayout(
    layout
) {
    if (!layout) {
        return DEFAULT_CARD_LAYOUT;
    }

    if (
        layout.regions
    ) {
        return layout;
    }

    if (
        layout.name &&
        CARD_LAYOUTS[
            layout.name
        ]
    ) {
        return CARD_LAYOUTS[
            layout.name
        ];
    }

    return DEFAULT_CARD_LAYOUT;
}